<script>
import {defineComponent} from 'vue'
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import RequisiteTable from "@js/components/Sections/Contacts/RequisiteTable.vue";
import {Link} from "@inertiajs/vue3";
import {useCallbackStore} from "@js/store/CallbackStore.js";

export default defineComponent({
    name: "AboutCompanyPage",
    components: {
        Link,
        RequisiteTable,
        Breadcrumbs,
        MobileTopBar,
    },
    setup() {
        const callbackStore = useCallbackStore()
        return {callbackStore}
    }
})
</script>

<template>
    <MobileTopBar/>
    <div class="container mb-5 md:mb-10">
        <Breadcrumbs/>
        <h1 class="text-2xl md:text-3xl font-bold mb-5">
            О компании
        </h1>

        <div class="relative grid grid-cols-12 gap-5 mb-5">
            <!-- Левая колонка -->
            <div class="col-span-12 md:col-span-8 grid grid-cols-1 gap-5">
                <!-- О компании -->
                <div class="bg-grayBg p-5 md:p-8 rounded-3xl">
                    <p class="mb-4">
                        <strong>ООО «Дорожные Плиты»</strong> — надежный поставщик железобетонных изделий. Компания
                        специализируется на производстве и продаже дорожных плит, используемых при строительстве дорог,
                        промышленных
                        объектов, подъездных путей и временных площадок.
                    </p>
                    <p class="mb-4">
                        Мы предлагаем широкий ассортимент бетонных плит разных типоразмеров, соответствующих требованиям
                        ГОСТ, что
                        гарантирует долговечность и устойчивость к нагрузкам. Благодаря собственному производству и
                        налаженной
                        логистике обеспечиваем своевременные поставки по Москве и Московской области.
                    </p>
                    <p class="mb-4">
                        <strong>ООО «Дорожные Плиты»</strong> сотрудничает со строительными компаниями, промышленными
                        предприятиями
                        и частными заказчиками, предоставляя качественные ЖБИ для различных задач. Работаем с любыми
                        объемами заказов,
                        гарантируя надежность продукции и профессиональный подход к каждому клиенту.
                    </p>

                    <button
                        @click.prevent="callbackStore.showBaseCallbackPopup"
                        class="max-md:w-full mt-4 flex justify-center items-center text-center border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-sm px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                        Заказать обратный звонок
                    </button>
                </div>

                <!-- Почему выбирают нас -->
                <div class="bg-grayBg p-5 md:p-8 rounded-3xl">
                    <h2 class="text-xl font-semibold mb-4">Почему выбирают нас</h2>
                    <ul class="list-disc list-outside ms-5 space-y-2">
                        <li>
                            <strong>Наличие продукции на складе.</strong> Мы располагаем одним из крупнейших складов
                            строительных
                            материалов в Москве (более 5 гектаров), что обеспечивает бесперебойные поставки и
                            оперативное выполнение заказов.
                        </li>
                        <li>
                            <strong>Качество продукции.</strong> Вся продукция соответствует ГОСТ. Мы тщательно отбираем
                            поставщиков
                            сырья и строго контролируем каждый этап производства. На полигонах работают
                            квалифицированные специалисты,
                            следящие за соблюдением технологий. Качество — наш приоритет.
                        </li>
                        <li>
                            <strong>Гибкие условия сотрудничества.</strong> Ценим каждого клиента и учитываем
                            индивидуальные
                            возможности при формировании условий. Наши финансовые специалисты подберут оптимальный
                            формат взаимодействия.
                        </li>
                        <li>
                            <strong>Комплексное снабжение объектов.</strong> Ассортимент включает более 2500
                            наименований —
                            вы можете заказать все необходимые строительные материалы в одном месте. Формируем удобный
                            график поставок.
                        </li>
                        <li>
                            <strong>Надежность и опыт.</strong> Более 25 лет в строительной отрасли — заслужили
                            репутацию
                            ответственного и стабильного партнера и накопили ценный опыт для эффективного решения задач.
                        </li>
                        <li>
                            <strong>Гарантия качества.</strong> Уверены в надежности продукции и при необходимости
                            готовы
                            предоставить замену. Доставку обеспечиваем собственным автопарком — более 50 единиц
                            транспорта
                            грузоподъемностью от 1 до 20 тонн. Оперативность — наш ключевой приоритет.
                        </li>
                        <li>
                            <strong>Индивидуальные решения.</strong> Современные технологии и опыт специалистов
                            позволяют
                            реализовывать нестандартные проекты в сфере поставок ЖБИ. Готовы обсудить особые требования
                            и предложить оптимальное решение.
                        </li>
                    </ul>
                </div>

                <!-- Ассортимент и соответствие ГОСТ -->
                <div class="bg-grayBg p-5 md:p-8 rounded-3xl">
                    <h2 class="text-xl font-semibold mb-4">Ассортимент и стандарты</h2>
                    <p class="mb-4">
                        В наличии дорожные плиты разных серий и типоразмеров для постоянных и временных покрытий, а
                        также сопутствующие
                        ЖБИ для подготовки площадки и обустройства территории. Все изделия производятся в соответствии с
                        ГОСТ, что
                        обеспечивает надежность в эксплуатации и стабильные характеристики.
                    </p>
                    <p>
                        Для уточнения наличия и подбора типоразмера свяжитесь с нашим специалистом — предложим решение
                        под ваши нагрузки,
                        геометрию и график строительства.
                    </p>
                </div>

                <!-- Логистика и регионы поставки -->
                <div class="bg-grayBg p-5 md:p-8 rounded-3xl">
                    <h2 class="text-xl font-semibold mb-4">Логистика и поставки</h2>
                    <p class="mb-4">
                        Благодаря собственному автопарку и отлаженной логистике выполняем поставки по Москве и
                        Московской области
                        точно в срок. Возможны также отгрузки по согласованному графику, включая ночные окна и усиленные
                        смены
                        под критичные этапы строительства.
                    </p>
                    <p class="mb-4">
                        Для консультации по маршрутам, подбору техники и стоимости доставки — оставьте заявку, и
                        менеджер оперативно свяжется с вами.
                    </p>

                    <div class="flex flex-wrap gap-3">
                        <button
                            @click.prevent="callbackStore.showBaseCallbackPopup"
                            class="max-md:w-full mt-1 flex justify-center items-center text-center border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-sm px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                            Оставить заявку
                        </button>
                        <Link :href="route('contacts')"
                              class="mt-1 flex justify-center items-center text-center border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-sm px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                            Контакты
                        </Link>
                    </div>
                </div>
            </div>
            <div class=" col-span-12 md:col-span-4">
                <div class="md:sticky md:top-24 border-2 border-baseColor rounded-3xl overflow-hidden">
                    <RequisiteTable/>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
</style>
